import { toObservable } from '@angular/core/rxjs-interop';

import { filter, map } from 'rxjs';

import { StateSignals } from '@ngrx/signals';

import { AuthState } from './auth.state';

export const authObservablePropsFactory = (store: StateSignals<AuthState>) => ({
  authToken$: toObservable(store._authToken),
  signedIn$: toObservable(store._user).pipe(filter(user => user !== undefined), map(Boolean)),
  signedOut$: toObservable(store._user).pipe(filter(user => user === null), map(Boolean)),
});
